// @flow

import { find } from 'lodash/fp';

import getPlayersFromGames from '../utils/getPlayersFromGames';
import { makeInitials } from '../utils/playerUtils';
import decodeChallenge from './decodeChallenge';

function decodeRapidfireChallenge(data, meta): Product {
  const players = getPlayersFromGames(data.games);
  return {
    id: data.id,
    rf3EnteredChallenge: find(ch => ch.rapidfire_type === 'rapidfire_3' && ch.entered)(
      data.challenges
    ),
    rf5EnteredChallenge: find(ch => ch.rapidfire_type === 'rapidfire_5' && ch.entered)(
      data.challenges
    ),
    challenges: data.challenges.map(ch => decodeChallenge(ch, meta)),
    fees: data.fees.map(section => ({
      ...section,
      value: section.value.map(v => v / 100)
    })),
    payStructures: data.pay_structures,
    matchUps: data.rules.tiers.map(tier =>
      tier.map(pId => {
        const player = players[pId];
        return {
          ...player,
          initials: makeInitials(player.name)
        };
      })
    ),
    startTime: data.start_time,
    status: data.status,
    sportId: data.sports[0].id,
    competitionId: data.competition_id
  };
}

export default decodeRapidfireChallenge;
